import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/lottery';

export default {
  langs,
  langName: 'lottery',
  mixins: [entryMixin],
  lotterySdk: {
    type: Object,
  },
  methods: {
    _getCoreSdk() {
      return this.lotterySdk;
    },
  }
};
